import { Component, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';

import { NegocioModel } from './Negocio.model';
import { ParamNegociosId } from './Negocio.model';
import { DefCiudadesId } from './Negocio.model';
import { DefCiudades } from './Negocio.model';
import { DefContribuyentes } from './Negocio.model';
import { OpcionModel } from '../Global/Opcion.model';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { ConfirmarEliminacionService } from '../Dialog/ConfirmarEliminacionService';



@Component({
	selector : 'negocio',
	templateUrl : './NegocioIndex.component.html',
	styleUrls  : ['../../../../styles.css']
})

/**
* @author Camilo
* @since  31/10/2017
**/
export class NegocioIndexComponent {
	
	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar:boolean;
	public btnEditar:boolean;
	public btnEliminar:boolean;
	public btnConsultar:boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //
	
	public negocios:Array<NegocioModel>;
	public guardando:boolean;

	public displayedColumns = ['Negocio', 'Nombre', 'Nit', 'Editar'];
	public dataDataBase:NegociosDatabase;
	public dataSource:ExampleDataSource;

	public ocultar: boolean = false;
	public mensaje: string = "";

	@ViewChild('filter') filter: ElementRef;


	constructor(private _serviciosGenerales:ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router:Router, public dialog: MatDialog, 
		private confirmarEliminacionService:ConfirmarEliminacionService)
	{
		this.negocios = new Array();
		this.guardando = false;

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.snackBar.dismiss();
	}

	ngOnInit()
	{
		this.cargarTabla();
	}

	private cargarTabla(){
		this.dataDataBase = new NegociosDatabase();
		
		this._serviciosGenerales.get('negocios', {param:0}).subscribe(
			result =>{
				this.negocios = new Array();
				for(let x of result){
					
					let negocioModel: NegocioModel = new NegocioModel(new ParamNegociosId(x.cnumcont, x.ntipoempresa), x.vnombrenegocio, x.cnit, x.nidcheck,x.dfechacreacion, x.vdireccion, 
						new DefCiudades(new DefCiudadesId(x.ccodigociudad, x.ccodigodepto,"169")), x.ntelefono, x.vcorreo,new DefContribuyentes('').nidcontribuyente = x.nidcontribuyente ,x.vregimen ,x.ccodcontab,0,0, "", 0, "",0,0, "");
					negocioModel.nestadot=x.nestado
					this.dataDataBase.addNegocio(
						negocioModel
						);
				}
				this.dataSource = new ExampleDataSource(this.dataDataBase);
			}, 
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los negocios", "X");
			}
			);

		Observable.fromEvent(this.filter.nativeElement, 'keyup')
		.debounceTime(150)
		.distinctUntilChanged()
		.subscribe(() => {
			if ( !this.dataSource )
			{
				return;
			}
			this.dataSource.filter = this.filter.nativeElement.value;
		});
	}

	editar(negocio:NegocioModel){
		console.log("Entró ", negocio);
		console.log(negocio);
		this._router.navigate(['/Negocio', negocio.id.cnumcont]);
	}
	
	agregar(){
		this._router.navigate(['/Negocio', '']);	
	}

	confirmacionDelete(negocio:NegocioModel){
		this.confirmarEliminacionService.abrirDialog({cnumcont:negocio.id.cnumcont}, 'eliminarNegocio');
		this.confirmarEliminacionService.eventoFin$.subscribe(r=>{
			this.cargarTabla();
		})

		console.log(negocio);
	/*	this._serviciosGenerales.delete('eliminarNegocio', {cnumcont:negocio.cnumcont}).subscribe(
			result =>{
				
				this.openSnackBar(result.mensaje, "X");

				if(result.error == false){
					console.log(result);
					this.cargarTabla();
				}
				
				
			},
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBar("Ocurrió un error al momento de eliminar el negocio", "X");
			});
			*/
			
		}

		verPrefijos(negocio:NegocioModel){
			this._router.navigate(['/Prefijo', negocio.id.cnumcont, 'd', 1]);
		}

		

		openSnackBar(message: string, action: string)
		{
			this.snackBar.open(message, action, {
				duration: 20000
			});
		}

		openSnackBarEspecial(message: string, action: string) {
			let snackBarRef =  this.snackBar.open(message, action);
	
			snackBarRef.onAction().subscribe(() => {
				console.log("Paso por aqui 1 notas");
	
				this.ocultar = false;
				this.mensaje = "";
			});
			
			let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
			
			if (shand.length != 0) {
					for (let i=0;i<shand.length;i++){
					shand[i].style.backgroundColor = "rgb(255 204 214)";
					}
				}
		}

	}




// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

export class NegociosDatabase
{
	
	dataChange: BehaviorSubject<NegocioModel[]> = new BehaviorSubject<NegocioModel[]>([]);

	get data(): NegocioModel[]
	{
		return this.dataChange.value;
	}

	addNegocio(negocio:NegocioModel)
	{
		const copiedData = this.data.slice();
		copiedData.push(negocio);
		this.dataChange.next(copiedData);
	}

	

}


export class ExampleDataSource extends DataSource<any>
{
	_filterChange = new BehaviorSubject('');

	get filter(): string
	{
		return this._filterChange.value;
	}

	set filter(filter: string)
	{
		this._filterChange.next(filter);
	}

	constructor(private _exampleDatabase: NegociosDatabase)
	{
		super();
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<NegocioModel[]>
	{
		const displayDataChanges = [
		this._exampleDatabase.dataChange,
		this._filterChange
		];

		return Observable.merge(...displayDataChanges).map(() => {
			return this._exampleDatabase.data.slice().filter((item: NegocioModel) => {
				let searchStr = (item.id.cnumcont + item.vnombrenegocio + item.cnit).toLowerCase();
				return searchStr.indexOf(this.filter.toLowerCase()) != -1;
			});
		});
	}

	disconnect()
	{
	}

	
}

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //
@Component({
	selector: 'confirmacionDeleteNegocio',
	templateUrl: 'confirmacionDeleteNegocio.html',
})
export class DialogConfirmacion {
	
	constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Negocio/NegocioIndex.component.ts